import { useLayoutEffect, useRef } from 'react'

import { Box, BoxProps, keyframes } from '@mui/material'

type Props = {
  fullScreen?: boolean
}

const iconSize = 11.25

const Ball = (props: BoxProps) => {
  return <Box sx={{ height: iconSize, width: iconSize, position: 'absolute', borderRadius: '50%', ...props.sx }} />
}

function Loading({ fullScreen }: Props) {
  const loadingLayoutRef = useRef<HTMLDivElement>(null)

  useLayoutEffect(() => {
    const loadingLayout = loadingLayoutRef.current
    if (!loadingLayout || typeof loadingLayout.getAnimations !== 'function') return

    const phase = Number(document.timeline.currentTime ?? performance.now()) % 1000
    loadingLayout.getAnimations({ subtree: true }).forEach((anim) => {
      anim.currentTime = phase
    })
  }, [])

  const spin = keyframes`
    from { -webkit-transform: rotate(0deg); }
    to { -webkit-transform: rotate(359deg); }`

  const topBall = keyframes`
    50% { top: -${iconSize * 2}px; }
    100% { top: -${iconSize}px; }`

  const rightBall = keyframes`
    50% { right: -${iconSize * 2}px; }
    100% { right: -${iconSize}px; }`

  const bottomBall = keyframes`
    50% { bottom: -${iconSize * 2}px; }
    100% { bottom: -${iconSize}px; }`

  const leftBall = keyframes`
    50% { left: -${iconSize * 2}px; }
    100% { left: -${iconSize}px; }`

  return (
    <Box
      id='loading-layout'
      ref={loadingLayoutRef}
      sx={{
        width: '60px',
        height: '60px',
        ...(fullScreen
          ? {
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)'
            }
          : {
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            })
      }}
    >
      <Box id='container' sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', width: '100%' }}>
        <Box sx={{ height: iconSize, width: iconSize, position: 'relative', animation: `${spin} 1s linear infinite` }}>
          <Ball
            id='top-ball'
            sx={{
              top: '-10px',
              background: '#3781F6',
              animation: `${topBall} 1s linear infinite`
            }}
          />
          <Ball
            id='right-ball'
            sx={{
              right: '-10px',
              background: '#61D299',
              animation: `${rightBall} 1s linear infinite`
            }}
          />
          <Ball id='bottom-ball' sx={{ bottom: '-10px', background: '#3781F6', animation: `${bottomBall} 1s linear infinite` }} />
          <Ball id='left-ball' sx={{ left: '-10px', background: '#3781F6', animation: `${leftBall} 1s linear infinite` }} />
        </Box>
      </Box>
    </Box>
  )
}

export default Loading
